import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography
} from "@mui/material";
import React from "react";
import {HighlightOff} from "@mui/icons-material";
import { DialogHeader } from '../../../../../../theme';

// region TypeScript Interfaces
interface ProfileValues {
    Id?: string | number;
    Shared?: boolean;
    [key: string]: unknown;
}

interface EnhancedSaveDialogProps {
    open: boolean;
    onClose: () => void;
    values: ProfileValues;
    disabled?: boolean;
    save: (values: ProfileValues) => void;
}
// endregion

export default function EnhancedSaveDialog(props: EnhancedSaveDialogProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {open, onClose, values, disabled, save} = props; // These vars are used

    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth={true}
                slotProps={{
                    paper: {
                        style: {
                            borderRadius: "12px"
                        }
                    }
                }}
        >
            <DialogTitle>
                <Grid item container justifyContent={"space-between"} alignItems={"center"}>
                    <Grid item container style={{flex: 0.5, flexDirection: "column"}}>
                        <DialogHeader>
                            Confirm Save
                        </DialogHeader>
                    </Grid>

                    <IconButton onClick={() => props.onClose()} size="large">
                        <HighlightOff style={{color: "red"}}/>
                    </IconButton>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Typography variant={"body1"} style={{fontSize: "16px"}}>
                    {"Are you sure you want to save this profile?"}
                    {values.Shared && " This profile is shared with your trading partners and will be updated for them as well."}
                    {values.Id && !values.Shared && " This profile is shared with other users at your company and will be updated for them as well."}
                </Typography>
            </DialogContent>
            <DialogActions style={{padding: "24px"}}>
                <Button variant="text" disabled={disabled} onClick={onClose}>No</Button>
                <Button variant="text" color="primary" disabled={disabled} onClick={() => props.save(values)}>Yes</Button>
            </DialogActions>
        </Dialog>
    );
}
